module.exports = __webpack_public_path__ + "static/media/womanCityPhone.9e024158.jpg";